/**
 * Save Feedback UseCase
 * Flutter source: lib/data/repository/feedback_repository.dart:15-53
 *   (`FeedbackRepository.saveFeedback(List<AppMedia> appMedias, String description)`
 *   — Flutter has no separate use-case layer; the repository method IS the single
 *   action) and the call site
 *   lib/presentation/screens/feedback/in_app_feedback_screen.dart:227-230
 *   (`bool saved = await FeedbackRepository().saveFeedback(...)`).
 *
 * Single-action, thin pass-through: submits one in-app feedback document and
 * returns the saved boolean. All orchestration (uid guard, sequential screenshot
 * upload, DTO build + Firestore write) lives in `FeedbackService.saveFeedback` —
 * this use case adds no business logic (lessons: "One use case = one action").
 *
 * Web parity reference: fetchUsersFeedbackUseCase.ts (sibling thin forwarding use
 * case with an injectable-service constructor).
 */
import { FeedbackService, feedbackService } from '@/domain/services/feedback/feedbackService';
import type { SaveFeedbackInput } from '@/domain/input/feedback/saveFeedbackInput';

export class SaveFeedbackUseCase {
  private feedbackServiceInstance: FeedbackService;

  constructor(feedbackServiceInstance: FeedbackService = feedbackService) {
    this.feedbackServiceInstance = feedbackServiceInstance;
  }

  async execute(input: SaveFeedbackInput): Promise<boolean> {
    return this.feedbackServiceInstance.saveFeedback(input);
  }
}

export const saveFeedbackUseCase = new SaveFeedbackUseCase();
